module.exports = __webpack_public_path__ + "media/images/front/company/postal_1-970ecbdca83f92393bb788ba9449faba.png";